// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__FIT9C","cell":"ColumnAccessor_cell__1izIO","firstCellAccent":"ColumnAccessor_firstCellAccent__qzQsQ"};